<template>
  <b-container class="d-flex align-items-center justify-content-center">
    <div id="who-main" class="spnod-admin__form--main d-flex align-items-center flex-column">
      <h3 class="h3 mb-1">Select Your Role</h3>
      <span class="text-muted mb-3">
        {{ isTablet ? 'Click' : 'Hover over' }} the ? to learn more
      </span>
      <RoleForm />
    </div>
  </b-container>
</template>

<script>
import RoleForm from '../../components/Forms/RoleForm'

export default {
  name: 'WhoAreYou',
  components: { RoleForm },
  computed: {
    isTablet() { return window.innerWidth <= 1200 }
  }
}
</script>

<style scoped>
  span {
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/app/Pages/AdminAuth/WhoAreYou.vue?a035c846